import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  FormHelperText,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { colors } from "../../Config/Colors";

export default function SelectOptions(props) {
  const {
    name,
    label,
    error = null,
    value,
    onChange,
    options,
    disabled = false,
  } = props;

  const [searchTerm, setSearchTerm] = useState("");

  return (
    <FormControl
      className="w-full"
      key={name}
      variant="outlined"
      {...(error && { error: true })}
    >
      <InputLabel
        sx={{
          color: "#6b7280",
          backgroundColor: "#f9fafb",
          paddingX: 1,
          fontSize: "14px",
        }}
      >
        {label}
      </InputLabel>
      <Select
        disabled={disabled}
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        onOpen={() => setSearchTerm("")}
        MenuProps={{
          PaperProps: {
            sx: { borderRadius: "12px", marginTop: 1, boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)" },
            style: { maxHeight: 300 },
          },
        }}
        sx={{
          backgroundColor: "#f9fafb",
          borderRadius: "12px",
          fontSize: "15px",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: error ? "#ef4444" : "#e5e7eb",
            borderWidth: "1px",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#d1d5db",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#6366f1",
            borderWidth: "2px",
          },
          "& .MuiSelect-select": {
            padding: "12px 14px",
          },
        }}
      >
        {options
          .filter((item) =>
            item.title.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .map((item) => (
            <MenuItem
              key={item.title}
              value={item.title}
              sx={{
                fontSize: "1.1rem",
                padding: "12px 16px",
                "&:hover": {
                  backgroundColor: colors.background.light,
                },
                "&.Mui-selected": {
                  backgroundColor: "#eef2ff",
                  color: "#4338ca",
                },
              }}
            >
              {item.title}
            </MenuItem>
          ))}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
